import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function ResetPassword() {
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const pathname = location.pathname.startsWith("/");
        if (pathname) {
            console.log("Adding classes to the body.");
            document.body.classList.add("bgyellow");
        }
    }, []);

    console.log("Reset password")

    // State for form inputs
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false); // State to toggle password visibility
    const [showConfirmPassword, setShowConfirmPassword] = useState(false); // State to toggle confirm password visibility

    // Extracting user_id from URL query parameters
    const user_id = new URLSearchParams(location.search).get("user_id");

    const handleResetPassword = (e) => {
        e.preventDefault();

        // Basic validation
        if (!password.trim() || !confirmPassword.trim()) {
            toast.error("Please enter both new password and confirm password");
            return;
        }

        if (password !== confirmPassword) {
            toast.error("Passwords do not match");
            return;
        }

        axios
            .post(`${process.env.REACT_APP_APIURL}business/password/reset`, {
                user_id: user_id,
                password: password,
            })
            .then((res) => {
                if (res.data.status === "success") {
                    toast.success("Your password has been successfully reset");
                    // Redirect to login or appropriate page after success
                    setTimeout(() => {
                        navigate("/login");
                    }, 3000);
                } else {
                    if (res.data.error && res.data.error.message) {
                        toast.error(res.data.error.message);
                    } else {
                        toast.error("An error occurred during password reset");
                    }
                }
            })
            .catch((err) => {
                console.error("Password reset error:", err.response?.data?.error?.message);
                toast.error(err.response?.data?.error?.message || "An unexpected error occurred.");
            });
    };

    return (

            <div className="container mt-5">
                <div className="row justify-content-center">
                    <div className="col-12 col-sm-10 col-md-8 col-lg-6 col-xl-5">
                        <div
                            className="card shadow-sm border-0"
                            style={{
                                borderRadius: '16px',
                                padding: '2rem',
                                backgroundColor: '#ffffff'
                            }}
                        >
                            {/* Header */}
                            <div className="text-center mb-4">
                                <div
                                    className="d-inline-flex align-items-center justify-content-center mb-3"
                                    style={{
                                        width: '64px',
                                        height: '64px',
                                        backgroundColor: '#FFC107',
                                        borderRadius: '16px'
                                    }}
                                >
                                    <i className="fas fa-key" style={{ fontSize: '24px', color: 'white' }}></i>
                                </div>
                                <h2 className="mb-2" style={{ fontSize: '1.75rem', fontWeight: '600', color: '#1a1a1a' }}>
                                    Create New Password
                                </h2>
                                <p className="text-muted mb-0" style={{ fontSize: '0.95rem', lineHeight: '1.5' }}>
                                    Your new password must be different from previously used passwords.
                                </p>
                            </div>

                            <form onSubmit={handleResetPassword}>
                                {/* New Password Field */}
                                <div className="mb-3">
                                    <div className="position-relative">
                                        <input
                                            type={showPassword ? "text" : "password"}
                                            className="form-control"
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                            placeholder="Enter new password"
                                            required
                                            style={{
                                                height: '52px',
                                                fontSize: '16px',
                                                border: '1px solid #e0e0e0',
                                                borderRadius: '12px',
                                                padding: '0 50px 0 16px',
                                                backgroundColor: '#fafafa'
                                            }}
                                            onFocus={(e) => {
                                                e.target.style.borderColor = '#FFC107';
                                                e.target.style.backgroundColor = '#ffffff';
                                            }}
                                            onBlur={(e) => {
                                                e.target.style.borderColor = '#e0e0e0';
                                                e.target.style.backgroundColor = '#fafafa';
                                            }}
                                        />
                                        <button
                                            type="button"
                                            className="btn position-absolute"
                                            onClick={() => setShowPassword(!showPassword)}
                                            style={{
                                                right: '12px',
                                                top: '50%',
                                                transform: 'translateY(-50%)',
                                                border: 'none',
                                                background: 'none',
                                                padding: '0',
                                                width: '24px',
                                                height: '24px'
                                            }}
                                        >
                                            <i
                                                className={`fas ${showPassword ? 'fa-eye' : 'fa-eye-slash'}`}
                                                style={{ color: '#666', fontSize: '16px' }}
                                            ></i>
                                        </button>
                                    </div>
                                    <label
                                        className="form-label mt-2 mb-0"
                                        style={{ fontSize: '0.875rem', fontWeight: '500', color: '#666' }}
                                    >
                                        New Password
                                    </label>
                                </div>

                                {/* Confirm Password Field */}
                                <div className="mb-4">
                                    <div className="position-relative">
                                        <input
                                            type={showConfirmPassword ? "text" : "password"}
                                            className="form-control"
                                            value={confirmPassword}
                                            onChange={(e) => setConfirmPassword(e.target.value)}
                                            placeholder="Confirm new password"
                                            required
                                            style={{
                                                height: '52px',
                                                fontSize: '16px',
                                                border: '1px solid #e0e0e0',
                                                borderRadius: '12px',
                                                padding: '0 50px 0 16px',
                                                backgroundColor: '#fafafa'
                                            }}
                                            onFocus={(e) => {
                                                e.target.style.borderColor = '#FFC107';
                                                e.target.style.backgroundColor = '#ffffff';
                                            }}
                                            onBlur={(e) => {
                                                e.target.style.borderColor = '#e0e0e0';
                                                e.target.style.backgroundColor = '#fafafa';
                                            }}
                                        />
                                        <button
                                            type="button"
                                            className="btn position-absolute"
                                            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                            style={{
                                                right: '12px',
                                                top: '50%',
                                                transform: 'translateY(-50%)',
                                                border: 'none',
                                                background: 'none',
                                                padding: '0',
                                                width: '24px',
                                                height: '24px'
                                            }}
                                        >
                                            <i
                                                className={`fas ${showConfirmPassword ? 'fa-eye' : 'fa-eye-slash'}`}
                                                style={{ color: '#666', fontSize: '16px' }}
                                            ></i>
                                        </button>
                                    </div>
                                    <label
                                        className="form-label mt-2 mb-0"
                                        style={{ fontSize: '0.875rem', fontWeight: '500', color: '#666' }}
                                    >
                                        Confirm New Password
                                    </label>
                                </div>

                                {/* Password Requirements */}
                                <div
                                    className="mb-4 p-3"
                                    style={{
                                        backgroundColor: '#FDF9F2',
                                        borderRadius: '12px',
                                        border: '1px solid #e9ecef'
                                    }}
                                >
                                    <div
                                        className="mb-2"
                                        style={{ fontSize: '0.875rem', fontWeight: '600', color: '#495057' }}
                                    >
                                        Password requirements:
                                    </div>
                                    <ul className="mb-0" style={{ fontSize: '0.8rem', color: '#5B5040', paddingLeft: '1.2rem' }}>
                                        <li>At least 8 characters long</li>
                                        <li>Include both upper and lowercase letters</li>
                                        <li>Include at least one number</li>
                                        <li>Include at least one special character</li>
                                    </ul>
                                </div>

                                {/* Submit Button */}
                                <button
                                    type="submit"
                                    className="btn w-100"
                                    style={{
                                        height: '52px',
                                        fontSize: '16px',
                                        fontWeight: '500',
                                        borderRadius: '12px',
                                        backgroundColor: '#FFC107',
                                        border: 'none',
                                        color: 'white',
                                        transition: 'all 0.2s ease'
                                    }}
                                    onMouseOver={(e) => e.target.style.backgroundColor = '#FFB300'}
                                    onMouseOut={(e) => e.target.style.backgroundColor = '#FFC107'}
                                    disabled={!password || !confirmPassword || password !== confirmPassword}
                                >
                                    Update Password
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
    );
}

export default ResetPassword;
